module.exports = __webpack_public_path__ + "trust-marks-submit-express.72e7b7.png";